export default __webpack_public_path__ + "static/media/c.b3deb634.svg";